var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadWithoutShoulder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3L3 21",
    stroke: "#2B323B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3L13 21",
    stroke: "#2B323B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.25C8 2.25 8.75 2.58579 8.75 3V4.5C8.75 4.91421 8.41421 4.25 8 4.25C7.58579 4.25 7.25 4.91421 7.25 4.5V3C7.25 2.58579 8 2.25 8 2.25ZM8 6.75C8 6.75 8.75 7.08579 8.75 7.5V10.5C8.75 10.9142 8.41421 10.25 8 10.25C7.58579 10.25 7.25 10.9142 7.25 10.5V7.5C7.25 7.08579 8 6.75 8 6.75ZM8 12.75C8 12.75 8.75 13.0858 8.75 13.5V16.5C8.75 16.9142 8.41421 16.25 8 16.25C7.58579 16.25 7.25 16.9142 7.25 16.5V13.5C7.25 13.0858 8 12.75 8 12.75ZM8 18.75C8 18.75 8.75 19.0858 8.75 19.5V21C8.75 21.4142 8.41421 20.75 8 20.75C7.58579 20.75 7.25 21.4142 7.25 21V19.5C7.25 19.0858 8 18.75 8 18.75Z",
    fill: "#2B323B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6239 8.60541C15.7775 8.85155 16.0439 9.00061 16.3353 9.00061H21.6647C21.9561 9.00061 22.2225 8.85155 22.3761 8.60541C22.5274 8.35699 22.541 8.05213 22.4122 7.79243L19.7452 2.46068C19.603 2.1784 19.3184 2 19 2C18.6816 2 18.397 2.1784 18.2548 2.46068L15.5878 7.79243C15.459 8.0544 15.4726 8.35699 15.6239 8.60541ZM19.3387 4.24922V6.40135C19.3387 6.58879 19.1874 6.74009 19 6.74009C18.8126 6.74009 18.6613 6.58879 18.6613 6.40135V4.24922C18.6613 4.06179 18.8126 3.91048 19 3.91048C19.1874 3.91048 19.3387 4.06179 19.3387 4.24922ZM18.6613 7.63661V7.39047C18.6613 7.20303 18.8126 7.05173 19 7.05173C19.1874 7.05173 19.3387 7.20303 19.3387 7.39047V7.63661C19.3387 7.82179 19.1874 7.97535 19 7.97535C18.8126 7.97535 18.6613 7.82179 18.6613 7.63661Z",
    fill: "#2B323B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadWithoutShoulder);
export default __webpack_public_path__ + "static/media/road-without-shoulder.be3b8bf49e9eeb8d05cb60a7ac0c56de.svg";
export { ForwardRef as ReactComponent };